// object builder wrapper interfaces

const AlertTypeInfo = 'info';
export const AlertTypeSuccess = 'success';
const AlertTypeWarning = 'warning';
const AlertTypeError = 'error';
export let OptinState;
(function (OptinState) {
  OptinState["OPTED_IN"] = "OPTED_IN";
  OptinState["OPTED_OUT"] = "OPTED_OUT";
  OptinState["AVAILABLE"] = "AVAILABLE";
  OptinState["REJECTED"] = "REJECTED";
  OptinState["UNAVAILABLE"] = "UNAVAILABLE";
})(OptinState || (OptinState = {}));
export const RequestStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};
const requestFulfilledStatuses = [RequestStatus.SUCCESS, RequestStatus.ERROR];
export const isRequestFulfilled = status => requestFulfilledStatuses.includes(status);